import React from 'react';
import { Persona } from '../../types/persona';
import { PersonaCard } from './PersonaCard';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';

interface PersonaGridProps {
  personas: Persona[];
  onPersonaSelect?: (personaId: string) => void;
  onViewDetails?: (personaId: string) => void;
  onDelete?: (persona: Persona) => void;
}

export const PersonaGrid: React.FC<PersonaGridProps> = ({
  personas,
  onPersonaSelect,
  onViewDetails,
  onDelete
}) => {
  const navigate = useNavigate();
  const { darkMode } = useTheme();
  if (personas.length === 0) {
    return (
      <div className={`text-center py-10 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
        No personas found matching your criteria.
      </div>
    );
  }

  const handleNavigateToDetails = (personaId: string) => {
    navigate(`/personas/${personaId}`);
  };

  return (
    <div className="grid gap-4 grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
      {personas.map(persona => (
        <PersonaCard
          key={persona.id}
          persona={persona}
          onSelect={onPersonaSelect}
          onViewDetails={onViewDetails}
          onNavigateToDetails={handleNavigateToDetails}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};
